module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.invoices) ? _c('f7-list', {
    staticClass: "itemList",
    attrs: {
      "accordion-list": "",
      "id": "invoices-item-received"
    }
  }, _vm._l((_vm.invoices), function(invoice) {
    return _c('f7-accordion-item', {
      key: invoice.IdInvoice,
      staticClass: "accordionForm"
    }, [_c('f7-accordion-toggle', {
      staticClass: "accordionToggle"
    }, [_c('ul', [_c('li', {
      staticClass: "swipeout",
      staticStyle: {
        "background": "#dcdcdc"
      }
    }, [_c('div', {
      staticClass: "item-content boxRequest"
    }, [_c('div', {
      staticClass: "item-media"
    }, [_c('div', {
      style: ({
        background: _vm.rectangleColor
      }),
      attrs: {
        "id": "greenRectangle"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "icon list-icon",
      class: _vm.getIcon(invoice.Status)
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('table', {
      staticStyle: {
        "table-layout": "fixed"
      },
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "width": "43%",
        "min-width": "43%",
        "max-width": "43%"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                        " + _vm._s(invoice.NameSeller) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "showSmallScreenOnly"
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.amnt') + ': ' + invoice.Amount + ' €') + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "showSmallScreenOnly statusLabel"
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.exec_date') + ' ') + " " + _vm._s(_vm._f("formatDate")(invoice.PaymentDate)) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "showSmallScreenOnly",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.invoiceid_label') + ': ' + invoice.InvoiceIdentifier) + "\n                      ")])]), _vm._v(" "), _c('td', {
      staticClass: "showSmallScreenOnly",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                        " + _vm._s(invoice.NameSeller) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "showSmallScreenOnly"
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.amnt') + ': ' + invoice.Amount + ' €') + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "showSmallScreenOnly statusLabel"
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.exec_date') + ' ') + " " + _vm._s(_vm._f("formatDate")(invoice.PaymentDate)) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "showSmallScreenOnly",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.invoiceid_label') + ': ' + invoice.InvoiceIdentifier) + "\n                      ")])]), _vm._v(" "), _c('td', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "width": "25%",
        "min-width": "25%",
        "max-width": "25%"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('common.amnt') + ': ' + invoice.Amount + ' €') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('div', {
      staticStyle: {
        "color": "#8e8e93"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.exec_date') + ' ') + " " + _vm._s(_vm._f("formatDate")(invoice.PaymentDate)) + "\n                      ")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "statusLabel"
    }, [_vm._v("\n                      " + _vm._s(_vm.getStatusLabel(invoice.Status)) + "\n                    ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "font-size": "12px",
        "text-align": "right"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('common.invoiceid_label') + ': ' + invoice.InvoiceIdentifier) + "\n                    ")])])])])])])])])]), _vm._v(" "), _c('f7-accordion-content', {
      staticClass: "background-document-form left-box"
    }, [_c('invoice-details', {
      staticClass: "container-document-form",
      attrs: {
        "invoice": invoice,
        "showMainDetails": _vm.showInvoiceMainDetails
      }
    })], 1)], 1)
  }), 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5beba4c3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5beba4c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/invoiceDetailPages/InvoicesList.vue
// module id = 2425
// module chunks = 2